import { render, staticRenderFns } from "./aiCallbot.vue?vue&type=template&id=7973e918&lang=pug&"
import script from "./aiCallbot.vue?vue&type=script&lang=js&"
export * from "./aiCallbot.vue?vue&type=script&lang=js&"
import style0 from "./aiCallbot.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports